import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-approve",
  "use": "icon-approve-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-approve\">\r\n  <path d=\"M800 192H640c0-70.4-57.6-128-128-128s-128 57.6-128 128H224c-17.6 0-32 14.4-32 32v704c0 17.6 14.4 32 32 32h576c17.6 0 32-14.4 32-32V224c0-17.6-14.4-32-32-32z m-288-32c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32z m-7.2 535.2l-45.6 45.6-45.6-45.6-89.6-90.4 45.6-45.6 90.4 90.4L664 445.6l45.6 45.6-204.8 204z\" p-id=\"3292\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol